//#TODO: WILL BE REMOVED WHEN react-router v6 support (Propmpt, usePrompt, useBlocker)
//Temporary solution to support dirty-form navigation blocking
import { createBrowserHistory } from "history";

export default createBrowserHistory();
